import { render, staticRenderFns } from "./realEstateTexts.vue?vue&type=template&id=9a3ef6ea&"
import script from "./realEstateTexts.vue?vue&type=script&lang=js&"
export * from "./realEstateTexts.vue?vue&type=script&lang=js&"
import style0 from "./realEstateTexts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports